// extracted by mini-css-extract-plugin
module.exports = {"table":"TradeUnionsTable_table__3CVrM","actionsWrap":"TradeUnionsTable_actionsWrap__3rPGa","minWidth":"TradeUnionsTable_minWidth__3l_VL"};